import { ReservationFormState, ReservationPartyDraft } from './Types/reservationTypes';
import { today } from '../Shared/Helpers/dateHelpers';
import { PaymentMethodType } from '../Shared/Types/paymentMethodTypes';

export const emptyReservationPartyDraft: ReservationPartyDraft = {
  partyType: '',
  firstName: '',
  lastName: '',
  organizationName: '',
  taxId: '',
  regon: '',
  email: '',
  phone: '',
  street: '',
  city: '',
  postalCode: '',
  countryCode: '',
};

export const initialReservationValues: ReservationFormState = {
  id: 0,
  createdAt: today(),
  bookingId: 0,
  applicantPartyId: undefined,
  applicantPartyDraft: {
    ...emptyReservationPartyDraft,
  },
  invoiceBuyerPartyId: undefined,
  fundingPartyId: undefined,
  invoiceBuyerPartyDraft: {
    ...emptyReservationPartyDraft,
  },
  fundingPartyDraft: {
    ...emptyReservationPartyDraft,
  },
  participants: [],
  declaredParticipantsCount: 1,
  effectiveParticipantsCount: undefined,
  totalPrice: 0,
  totalPriceOverride: null,
  discountAmount: null,
  source: 0,
  offerBoardingPlaceId: undefined,
  selectedOfferOptions: [],
  unitPrice: 0,
  notes: [],

  // Payment tracking defaults (stored in database)
  // NOTE: paymentMethod will be auto-detected by backend, initial value is just a default
  paymentMethod: PaymentMethodType.Transfer,
  paymentStatus: 'Nieopłacona', // Legacy field
  paidAmount: 0, // Cash payments (updated by KP/KW documents)
  nonCashPaymentAmount: 0, // Transfer/Card payments (manual entry)
  paidAt: undefined,
  paymentComment: undefined,

  // Computed payment fields (calculated by backend, read-only in frontend)
  totalPaidAmount: 0, // paidAmount + nonCashPaymentAmount
  computedPaymentMethod: PaymentMethodType.Transfer, // Auto-detected: Mixed/Cash/Transfer
  computedPaymentStatus: 'Nieopłacona', // Auto-calculated: Opłacona/Częściowo/Nieopłacona
};

export const initialParticipantValues = {
  id: 0,
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  birthDate: '',
  address: '',
  city: '',
  zipCode: '',
};
